import set from 'lodash/set';

export const mutations = {
  SET_FEATURE_STATE (state, { featureName, enabled }) {
    set(state, featureName, enabled);
  }
};
